module.exports = __webpack_public_path__ + "dict/img/bg.bb9f0e1f.png";